import { Model } from './model';
import { Client } from './client';
import { RegionAttachable, Widget } from './widget';

export class ClientFeedConfiguration {
  client: Client;
  id: string;
  name: string;
  parser: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.parser = data.parser;
    }
  }

  toJson() {
    return {};
  }
}

export class ProjectFeed extends Model {
  url: string;
  configuration: ClientFeedConfiguration;

  constructor(data?) {
    super(data);
    if (data) {
      this.url = data.url;
      this.configuration = new ClientFeedConfiguration(data.configuration);
    }
  }

  toJson() {
    return {
      url: this.url,
      configuration: this.configuration.id
    };
  }
}

export class ProjectFeedParseResult {
  projectName?: string;
  projectSlug?: string;
  objects: any;

  constructor(data: any) {
    this.projectName = data.project.name;
    this.projectSlug = data.project.slug;
  }
}

export class ProjectFeedLog extends Model {
  status: string;
  payload: any;

  constructor(data?: any) {
    super(data);
    this.payload = data.payload;
    this.status = data.status;

  }

  static fromJson(data: any): ProjectFeedLog {
    return new ProjectFeedLog(data);
  }

  toJson(): any {
    return undefined;
  }
}

export interface ProjectInfo {
  objectCount: number;
  widgetCount: number;
  projectCount: number;
}

export type ProjectStatus = "Active" | "Upcoming" | "Archived"

export const ProjectStatus = {
  Active: "Active" as ProjectStatus,
  Upcoming: "Upcoming" as ProjectStatus,
  Archived: "Archived" as ProjectStatus
};

export class Project extends Model implements RegionAttachable {
  name: string;
  slug: string;
  root: Project;
  parent: Project;
  children: Project[];
  feed: ProjectFeed;
  client: Client;
  info: ProjectInfo;
  status: ProjectStatus;
  widgets: Widget[];
  objectFields: ProjectObjectField[] = [];
  objectStatusNames: any;

  constructor(data?) {
    super(data);

    if (data) {
      this.name = data.name;
      this.slug = data.slug;
      this.parent = data.parent ? new Project(data.parent) : null;
      this.root = data.root ? new Project(data.root) : null;
      this.feed = data.feed ? new ProjectFeed(data.feed) : null;
      this.client = data.client ? new Client(data.client) : null;
      this.status = ProjectStatus[data.status];

      if (data.object_fields) {
        this.objectFields = data.object_fields.data.map(f => {
          return new ProjectObjectField(f);
        });
      }

      if (data.object_status_names) {
        this.objectStatusNames = [];
        data.object_status_names.data.forEach(s => {
          this.objectStatusNames[s.status] = s.name;
        });
      }

      this.children = data.children && data.children.data ? data.children.data.map((p) => {
        let child = new Project(p);
        child.parent = this;
        return child;
      }) : [];

      if (data.widgets) {
        this.widgets = data.widgets.data.map(w => {
          return new Widget(w);
        })
      }

      if (data.feed) {
        this.feed = new ProjectFeed(data.feed);
      }

      if (data.info) {
        this.info = {
          objectCount: data.info.object_count,
          widgetCount: data.info.widget_count,
          projectCount: data.info.project_count
        };
      } else {
        this.info = {
          objectCount: null,
          widgetCount: null,
          projectCount: null
        };
      }
    }
  }

  toJson(): any {
    return {
      client_id: this.client.id,
      name: this.name,
      slug: this.slug,
      status: this.status,
      parent_id: this.parent ? this.parent.id : null,
      feed: this.feed ? this.feed.toJson() : null,
      object_fields: this.objectFields.map(f => f.toJson()),
      object_status_names: this.objectStatusNames
    };
  }

  getId() {
    return this.id;
  }

  text() {
    return this.name;
  }
}


export class ProjectListFilter {
  //statuses: ProjectStatus[] = [];
  searchString: string;
  clients: number[] = [];
  statusMap: any = {};

  get statuses(): ProjectStatus[] {
    let statuses = [];

    Object.keys(this.statusMap).forEach(k => {
      if (this.statusMap[k]) {
        statuses.push(k);
      }
    });
    return statuses;
  }

  set client(client: number) {
    this.clients = [client];
  }

  get client(): number {
    return this.clients[0] > 0 ? this.clients[0] : null;
  }
}


export class ProjectTree extends Model {
  name: string;
  slug: string;
  status: ProjectStatus;
  children: ProjectTree[];

  constructor(data?) {
    if (data) {
      super(data);

      this.name = data.name;
      this.slug = data.slug;
      this.status = ProjectStatus[data.status];

      this.children = data.children ? data.children.data.map(c => {
        return new ProjectTree(c);
      }) : [];
    }
  }

  toJson(): any {
    return undefined;
  }
}

export class ProjectObjectField extends Model {
  field: ObjectField;
  isPublic: boolean;

  constructor(data?: any) {
    super(data);
    if (data) {
      this.field = new ObjectField(data.field);
      this.isPublic = data.public;
    }
  }

  toJson(): any {
    return {
      id: this.field.id,
      public: this.isPublic
    }
  }
}

export class ObjectField extends Model {
  key: string;
  type: string;
  label: string;

  constructor(data?) {
    if (data) {
      super(data);

      this.key = data.key;
      this.type = data.type;
      this.label = data.label;
    }
  }

  toJson(): any {
  }

}



// WEBPACK FOOTER //
// ./src/app/models/project.ts